import React, { createContext, useEffect } from 'react';
import socketService from '../services/socket';

interface SocketContextType {
  sendMessage: (event: string, data: unknown) => void;
}

export const SocketContext = createContext<SocketContextType | undefined>(undefined);

export const SocketProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  useEffect(() => {
    socketService.connect(`${import.meta.env.VITE_BACKEND_URL}`);

    return () => {
      socketService.disconnect();
    };
  }, []);

  const sendMessage = (event: string, data: unknown) => {
    socketService.sendMessage(event, data);
  };

  return <SocketContext.Provider value={{ sendMessage }}>{children}</SocketContext.Provider>;
};
